import { ProDatePicker } from '@bedrock/eed-react';
import dayjs from 'dayjs';
import React from 'react';
import { FC } from 'react';

export const ProCustomFieldDate: FC<any> = (props) => {
  const render = (value: any) => {
    return `${value ? dayjs(value).format('YYYY-MM-DD') : '-'}`;
  };
  return (
    <ProDatePicker {...props} fieldProps={{ range: false }} render={render} />
  );
};
